define([
	"dojo/_base/declare",
	"src/c8-platform/service/aggregateStoreService",
	"csi/action/Controller"
], function(declare, {clearAggregateStoreCaches}, Controller) {

	return declare(Controller, {
		constructor: function(/*Object*/params) {
			// summary: on data sheets refresh button could belong to nested view even though the toolbar appears
			// above root view. In this case, change the refresh widget to the root view.
			var view = this.widget.getToolbarContainerView();
			if (view && !view.toolbarNode) {
				this.widget = view;
			}
		},

		postProcessSuccess: function() {
			// summary: reset switchboard store as well as view
			const {widget} = this;
			const switchboard = widget.getSwitchboard();

			this.setProgress();

			// clear aggregate store caches when user explicitly decides to refresh
			clearAggregateStoreCaches();

			const dfd = switchboard?.refreshStore(switchboard.get("value"), true);

			this.when(dfd, () => {
				widget.refreshWidget();
			});
		}
	});
});